module.exports = __webpack_public_path__ + "img/about1.adf39b21.png";